/**
 * Approved-forecast freeze reference carried into scenarioFreeze (1.9). Only the
 * server-side freeze id + SHA-256 + count travel — never per-well numbers — so a
 * saved scenario names exactly which approved forecast set it was built against.
 */
const KEY = (dealId) => `d2d.assetForecastFreeze.${dealId}`;

export function pickForecastFreezeRef(f) {
  if (!f || typeof f !== 'object' || !/^[a-f0-9]{64}$/.test(f.contentSha256 || '')) return null;
  return {
    freezeId: Number(f.freezeId) || null,
    contentSha256: f.contentSha256,
    approvedCount: Number(f.approvedCount) || 0,
    createdAt: f.createdAt || null,
  };
}

export function saveForecastFreezeRef(dealId, f, storage = globalThis.localStorage) {
  const ref = pickForecastFreezeRef(f);
  if (!ref || !storage) return null;
  storage.setItem(KEY(dealId), JSON.stringify(ref));
  return ref;
}

export function readForecastFreezeRef(dealId, storage = globalThis.localStorage) {
  try {
    return pickForecastFreezeRef(JSON.parse(storage?.getItem(KEY(dealId)) || 'null'));
  } catch {
    return null;
  }
}
